import merge from 'lodash/merge'
import {BRANDS, LOGIN_CASES, LANGUAGES} from 'const'
import {getLang} from 'utils/stringUtils'
import twentyminTheme from 'theme/shared/themes/twentymin'
import {getFavicon, getFooterLogosByBrandList, getHeaderLogo} from '../commonHelper'
import {isProd} from 'utils/envUtils'

const lang = getLang(window.location.search) || 'de'
const brandLang = lang === 'fr' ? 'fr' : 'de'
const brandUrl = `https://www.lessentiel.lu/${brandLang}`
const otherBrandsLogos = getFooterLogosByBrandList([BRANDS.lessentiel, BRANDS.twentymin])
const authorizeRedirectURL = {
  [LANGUAGES.FR]: isProd()
    ? 'https://api.lessentiel.lu/user/v1/session/new?target_uri=https%3A%2F%2Fwww.lessentiel.lu%2Ffr&lang=fr&tenantId=18'
    : 'https://api.lessentiel.dev/user/v1/session/new?target_uri=https%3A%2F%2Fwww.lessentiel.dev%2Ffr&lang=fr&tenantId=18',
  [LANGUAGES.DE]: isProd()
    ? 'https://api.lessentiel.lu/user/v1/session/new?target_uri=https%3A%2F%2Fwww.lessentiel.lu%2Fde&lang=de&tenantId=19'
    : 'https://api.lessentiel.dev/user/v1/session/new?target_uri=https%3A%2F%2Fwww.lessentiel.dev%2Fde&lang=de&tenantId=19',
}[brandLang]

export default merge({}, twentyminTheme, {
  brand: {
    url: brandUrl,
    name: BRANDS.lessentiel,
    favicon: getFavicon(BRANDS.lessentiel),
    fontColor: '#323232',
    support: `https://consent.onelog.ch/?lang=${lang}#/support`,
    authorizeRedirectURL,
  },
  config: {
    emailOnlyRegister: ({loginCase}) => loginCase === LOGIN_CASES.GENERAL,
    swissIdLanding: false,
    marketingOnePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
    newsletterOnePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
    onePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
    marketingConsent: true,
    newsletterConsent: true,
    useCircularSocialLogin: true,
  },
  shell: {
    header: {
      logo: {
        src: {
          default: getHeaderLogo(BRANDS.lessentiel),
        },
      },
    },
  },
  otherBrandsLogos,
  social: {
    title: {
      fontSize: '16px',
    },
  },
})
